import React, { ReactNode } from "react";
import { alertConfig, alertConfigType } from "./alert.config";
import { Text } from "@fluentui/react-components";
import { threatConfig, ThreatType } from "../threat/threat.config";

type AlertBoxProps = {
    type: alertConfigType | ThreatType;
    title: string;
    description?: string;
    children?: ReactNode;
    aiGenerated?: boolean;
};

export const AlertBox = ({
    type,
    title,
    description,
    aiGenerated = false,
    children,
}: AlertBoxProps) => {
    const { icon: Icon, color, bgColor } = alertConfig[type] || threatConfig[type] || {};

    return (
        <div
            style={{
                display: "flex",
                gap: "0.5rem",
                background: bgColor,
                border: `2px solid ${color}`,
                borderRadius: "8px",
                padding: "14px",
                alignItems: "flex-start",
                position: "relative",
            }}
        >
            <div>
                <Icon style={{ color, fontSize: "24px" }} />
            </div>
            <div>
                {title && (
                    <Text weight="bold" style={{ color }}>
                        {title}
                    </Text>
                )}
                {description && (
                    <Text block style={{ marginTop: 4 }}>
                        {description}
                    </Text>
                )}
                {children}
                {aiGenerated && (
                    <Text italic size={200} style={{ marginTop: 8, display: "block", textAlign: "right" }}>
                        ✨ AI-generated result.
                    </Text>
                )}
            </div>
        </div>
    );
};
